import { InternalError } from './parsers/error';
import urlTypes from './url-types';


export default function parseUrl(url, skipVideos = false) {
  const idRegexp = '([\\w\\-]+)';
  let matched;

  if (!skipVideos) {

    /* Try to parse url as video */
    // Parse https://youtu.be/2IH-8tNQA_zSs format
    matched = new RegExp(`youtu\\.be\\/${idRegexp}`).exec(url);

    // Parse https://www.youtube.com/watch?v=2IH-8tNQA_zSs&feature=youtu.be format
    if (!matched) {
      matched = new RegExp(`youtube\\.com\\/watch\\?.*v=${idRegexp}`).exec(url);
    }

    if (!matched) {
      matched = new RegExp(`youtube\\.com\\/(?:v|embed)\\/${idRegexp}`).exec(url);
    }

    if (matched) {
      return Promise.resolve({
        id: matched[1],
        type: urlTypes.VIDEO,
      });
    }
  }

  /* Try to parse url as playlist */
  // Parse https://www.youtube.com/playlist?list=PLEAPYCvF3PpFGPDGD_AHR9m8zqNxrky_j format
  matched = new RegExp(`youtube\\.com\\/.*list=${idRegexp}`).exec(url);

  if (matched) {
    return Promise.resolve({
      id: matched[1],
      type: urlTypes.PLAYLIST,
    });
  }

  /* Try to parse url as channel */
  // Parse https://www.youtube.com/channel/UCAwuAYBCPm7l-Drg7rktLhQ format
  matched = new RegExp(`youtube\\.com\\/channel\\/${idRegexp}`).exec(url);

  if (matched) {
    return Promise.resolve({
      id: matched[1],
      type: urlTypes.CHANNEL,
    });
  }

  /* Try to parse url as user */
  // Parse https://www.youtube.com/user/vlogbrothers format
  matched = new RegExp(`youtube\\.com\\/user\\/${idRegexp}`).exec(url);

  if (matched) {
    return Promise.resolve({
      id: matched[1],
      type: urlTypes.USER_NAME,
    });
  }

  return Promise.reject(new InternalError(400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parse-url.js